import { LoadingState } from '@main/complykit';
import { defaultAlertDialogContext } from '@main/ui';
import { createRouter } from '@tanstack/react-router';

import { homeRoute } from './routes';
import { rootRoute } from './routes/__root';
import { route404 } from './routes/404';
import { fileViewerRoute } from './routes/file/viewer';
import { manageOrganizationsRoute } from './routes/organizations';
import { signInRoute } from './routes/signin';
import { usersRoute } from './routes/users';

const routeTree = rootRoute.addChildren([
  signInRoute.addChildren([
    homeRoute,
    manageOrganizationsRoute,
    usersRoute,
    fileViewerRoute,
    route404,
  ]),
]);

export const router = createRouter({
  routeTree,
  scrollRestoration: true,
  defaultPendingComponent: () => <LoadingState />,
  context: {
    dialog: defaultAlertDialogContext,
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
